import {createPinia} from "pinia";
import {autoAnimatePlugin} from "@formkit/auto-animate/vue";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import Ripple from "primevue/ripple";
import StyleClass from "primevue/styleclass";
import {PerfectScrollbarPlugin} from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/style.css";
import Theme from "../Theme/theme";
import "swiper/css/bundle";
import "./quill-custom.css";
import type {Plugin} from "vue";
import Quill from "quill";
import Rollbar from "rollbar";
import config from "./rollbar.config";

const rollbar = new Rollbar(config);
export default {
    install: (app) => {
        //TODO WTF is this?
        // Add polyfill for getSemanticHTML method to Quill prototype
        if (Quill && !Quill.prototype.getSemanticHTML) {
            Quill.prototype.getSemanticHTML = function () {
                return this.root.innerHTML;
            };
        }

        app.config.errorHandler = (error, vm, info) => {
            rollbar.error(error, {info});
        };
        app.provide("rollbar", rollbar);

        const pinia = createPinia();
        app.use(pinia);
        app.use(PrimeVue, {
            unstyled: true,
            pt: Theme,
            ptOptions: {
                mergeProps: true,
            },
            theme: {
                options: {
                    darkModeSelector: ".dark",
                },
            },
        });
        app.use(autoAnimatePlugin);
        app.use(ConfirmationService);
        app.use(ToastService);
        app.use(PerfectScrollbarPlugin);

        dayjs.extend(advancedFormat);
        dayjs.extend(customParseFormat);
        dayjs.extend(utc);
        dayjs.extend(timezone);
        dayjs.extend(isSameOrBefore);
        dayjs.tz.setDefault("UTC");

        app.provide("date", dayjs);
        app.directive("ripple", Ripple);
        app.directive("tooltip", Tooltip);
        app.directive("styleclass", StyleClass);

        axios.interceptors.response.use(
            (response: any) => response,
            (error: any) => {
                console.log(error);
                // if (error.status === 401 || error.response?.status === 401) {
                //     if (
                //         window.location.pathname !== "/" &&
                //         window.location.pathname !== "/login" &&
                //         window.location.pathname !== "/register" &&
                //         !window.location.pathname.includes("/password-reset") &&
                //         window.location.pathname !== "/forgot-password"
                //     ) {
                //         sessionStorage.removeItem("user");
                //         useMainStore().user = null;
                //         window.location.href = "/";
                //     }
                // }
                return Promise.reject(error);
            },
        );
    },
    mounted() {
        (this as any).$primevue.config.ripple = true;
    },
} satisfies Plugin;
